import moment from 'moment';
import { uid } from 'uid';

export const newRoomIdGet = async () => {

    const timeeStamp = moment().unix();
    const unickId = uid(16);
    return `room-${unickId}-${unickId}`;

}